export default "__VITE_ASSET__ca668f4c__"